module.exports = __webpack_public_path__ + "icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = 628
// module chunks = 0